import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild, OnDestroy, Renderer2, Inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';

@Component({
  selector: 'app-rag-chatbot',
  imports: [CommonModule, RouterModule],
  standalone: true,
  templateUrl: './rag-chatbot.component.html',
  styleUrl: './rag-chatbot.component.scss'
})
export class RagChatbotComponent implements OnInit, AfterViewInit,OnDestroy {
  constructor(private router: Router, private activatedRoute: ActivatedRoute,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private _document: Document
  ) { }
  private jsonLdScript: any;
  ngOnInit(): void {
    this.injectSchemaMarkup();
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route: { data: any; }) => route.data)
    )
      .subscribe((event: any) => {
        if (this.router.url === '/blogs/rag-chatbot') {
          // this.updateDescription(event.description, event.keywords, event.title);
        }
      });
  }
  ngOnDestroy(): void {
    this.removeSchemaMarkup();
  }
  injectSchemaMarkup(): void {
    const fullGraphSchema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/rag-chatbot#webpage",
          "url": "https://www.kalpitatechnologies.com/tech-blogs/rag-chatbot",
          "name": "RAG Chatbots Explained: How Retrieval-Augmented Generation is Reshaping AI Conversations | Kalpita Technologies",
          "description": "Comprehensive guide to RAG Chatbots explaining Retrieval-Augmented Generation, how RAG chatbots work, key technologies, use cases, and benefits.",
          "isPartOf": { "@id": "https://www.kalpitatechnologies.com/#website" },
          "inLanguage": "en",
          "datePublished": "2025-06-30"
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/rag-chatbot#breadcrumb",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "item": { "@type": "WebPage", "@id": "https://www.kalpitatechnologies.com/", "name": "Home" } },
            { "@type": "ListItem", "position": 2, "item": { "@type": "WebPage", "@id": "https://www.kalpitatechnologies.com/tech-blogs/blog", "name": "Blog Index" } },
            { "@type": "ListItem", "position": 3, "item": { "@type": "WebPage", "@id": "https://www.kalpitatechnologies.com/tech-blogs/rag-chatbot", "name": "RAG Chatbots Explained" } }
          ]
        },
        {
          "@type": "BlogPosting",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/rag-chatbot#article",
          "headline": "RAG Chatbots Explained: How Retrieval-Augmented Generation is Reshaping AI Conversations",
          "articleBody": "In the ever-evolving landscape of artificial intelligence, chatbots have evolved into intelligent systems capable of understanding, reasoning, and delivering relevant responses...",
          "author": {
            "@type": "Person",
            "name": "Grace Catharine",
            "url": "https://www.kalpitatechnologies.com/author/grace-catharine"
          },
          "publisher": {
            "@type": "Organization",
            "name": "Kalpita Technologies",
            "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
          },
          "datePublished": "2025-06-30",
          "image": "https://www.kalpitatechnologies.com/assets/resources/blog/RAG-Chatbot/RAGbanner.webp"
        },
        {
          "@type": "FAQPage",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/rag-chatbot#faq",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What is a RAG Chatbot and how does it differ from traditional chatbots?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "A RAG (Retrieval-Augmented Generation) Chatbot is a conversational AI that combines search and generative AI to create dynamic, contextual conversations grounded in real data."
              }
            }
          ]
        },
        {
          "@type": "Organization",
          "@id": "https://www.kalpitatechnologies.com/#organization",
          "name": "Kalpita Technologies",
          "url": "https://www.kalpitatechnologies.com/",
          "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
        }
      ]
    };

    this.jsonLdScript = this.renderer.createElement('script');
    this.jsonLdScript.type = 'application/ld+json';
    this.jsonLdScript.text = JSON.stringify(fullGraphSchema);
    this.renderer.appendChild(this._document.head, this.jsonLdScript);
  }

  removeSchemaMarkup(): void {
    if (this.jsonLdScript) {
      this.renderer.removeChild(this._document.head, this.jsonLdScript);
      this.jsonLdScript = null;
    }
  }
  // updateDescription(desc: string, keywords: string, title: string) {
  //   this.seoService.updateDescription(desc);
  //   this.seoService.updateMetaKeywords(keywords);
  //   this.seoService.updateTitle(title);
  // }

  nav(url: any) {
    this.router.navigateByUrl(url)
  }

  @ViewChild('tableresponsiveImage', { static: false }) image!: ElementRef<HTMLImageElement>;

  originalWidth = 1920;
  originalHeight = 797;

  ngAfterViewInit(): void {
    this.resizeImageMap();
    this.image.nativeElement.onload = () => this.resizeImageMap();
  }

  @HostListener('window:resize')
  resizeImageMap(): void {
    const img = this.image.nativeElement;
    if (!img) return;

    const wRatio = img.clientWidth / this.originalWidth;
    const hRatio = img.clientHeight / this.originalHeight;

    document.querySelectorAll<HTMLAreaElement>('map[name="table-image-map"] area')
      .forEach(area => {
        const rawCoords =
          area.getAttribute('data-original-coords')
          || area.getAttribute('coords')
          || '';
        if (!rawCoords) return;

        area.setAttribute('data-original-coords', rawCoords);
        const scaled = rawCoords
          .split(',')
          .map((c, i) =>
            Math.round(
              Number(c) * (i % 2 === 0 ? wRatio : hRatio)
            )
          )
          .join(',');

        area.setAttribute('coords', scaled);
      });
  }

  scrollToSection(sectionId: string): void {
    const el = document.getElementById(sectionId);
    if (!el) return;
    const yOffset = 5 * 16;
    const top =
      el.getBoundingClientRect().top + window.pageYOffset - yOffset;
    window.scrollTo({ top, behavior: 'smooth' });
  }
}
